import { styled } from 'styled-components';
import { Card, Form } from 'antd';

export const ContentCard = styled(Card)`
  max-width: 600px;
  margin: 0 auto;
`;

export const StyledForm = styled(Form)`
  margin-top: 24px;
` as typeof Form;

export const FormItem = styled(Form.Item)`
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
`;
